import { render, staticRenderFns } from "./pedidos.vue?vue&type=template&id=e080c780&scoped=true"
import script from "./pedidos.vue?vue&type=script&lang=js"
export * from "./pedidos.vue?vue&type=script&lang=js"
import style0 from "./pedidos.vue?vue&type=style&index=0&id=e080c780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e080c780",
  null
  
)

export default component.exports